import { useIntl } from 'react-intl';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { EmptyState } from '@xing-com/empty-state';
import { IllustrationSpotCheck } from '@xing-com/illustrations';

export const NewJobsSeenBanner: React.FC = () => {
  const { formatMessage } = useIntl();
  const { deleteSearchParameter } = useSearchParameter();

  const onClick = (): void => {
    deleteSearchParameter(SEARCH_STATE_PARAMS.since, { replace: false });
  };

  return (
    <EmptyState
      variant="engage"
      illustration={IllustrationSpotCheck}
      headlineText={formatMessage({
        id: 'JOBS_SEARCH_FILTER_SINCE_EMPTY_STATE_HEADLINE',
      })}
      bodyCopyText={formatMessage({
        id: 'JOBS_SEARCH_FILTER_SINCE_EMPTY_STATE_SUBHEADLINE',
      })}
      buttonText={formatMessage({
        id: 'JOBS_SEARCH_FILTER_SINCE_EMPTY_STATE_BUTTON',
      })}
      buttonProps={{ onClick }}
    />
  );
};
